<app-shared-workshop-card
  [title]="workshop.title"
  [coverImage]="workshop.coverImage"
  [detailsLink]="workshop.courseLink"
  [description]="showDescription ? workshop.description : undefined"
  [isRegisteredAndPending]="isRegisteredAndPending"
  [isRegisteredAndApproved]="isRegisteredAndApproved"
  [isRegisteredAndRejected]="isRegisteredAndRejected"
  [rows]="cardRows"
  [actions]="cardActions"
></app-shared-workshop-card>

<p-dialog
  [(visible)]="showApprovalPromptPopup"
  [modal]="true"
  [rtl]="true"
  [closable]="true"
  [dismissableMask]="true"
  styleClass="p-fluid"
>
  <app-registration-approval-prompt></app-registration-approval-prompt>
</p-dialog>
